import request from '../utils/request'

export function donateList (params) {
  return request({
    url: '/donate/log/list',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}
export function userCount (params) {
  return request({
    url: '/donate/log/user',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

export function userDonateLogList (params) {
  return request({
    url: '/donate/log/user/list',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

export function userDonateList (params) {
  return request({
    url: '/project/user/list',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

// 捐赠统计
export function userDonateCount (params) {
  return request({
    url: '/donate/log/user/count',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/donate.js